"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var axios_1 = __importDefault(require("axios"));
var dialog_1 = __importDefault(require("./dialog"));
axios_1.default.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
var HttpService = /*#__PURE__*/function () {
  function HttpService() {
    var _this = this;
    var isShowDialog = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    _classCallCheck(this, HttpService);
    this.isShowDialog = true;
    this.isShowDialog = isShowDialog;
    var request = axios_1.default.create({
      timeout: 50000
    });
    request.interceptors.request.use(function (config) {
      _this.showDialog();
      return config;
    }, function (error) {
      _this.closeDialog();
      Promise.reject({
        "status": "ERROR",
        "message": error
      });
    });
    request.interceptors.response.use(function (res) {
      _this.closeDialog();
      return res;
    }, function (error) {
      _this.closeDialog();
      return Promise.reject({
        "status": "ERROR",
        "message": error.message
      });
    });
    this.instance = request;
  }
  _createClass(HttpService, [{
    key: "setShowDialog",
    value: function setShowDialog(_isShowDialog) {
      this.isShowDialog = _isShowDialog;
    }
  }, {
    key: "showDialog",
    value: function showDialog() {
      if (this.isShowDialog) {
        dialog_1.default.fire({
          html: "Processing...",
          didOpen: function didOpen() {
            dialog_1.default.showLoading();
          }
        });
      }
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      if (this.isShowDialog) {
        dialog_1.default.close();
      }
    }
  }]);
  return HttpService;
}();
exports.default = new HttpService();